import React from 'react';
import PropTypes from 'prop-types';
import css from './SlotTypeDropdown.scss';
import AccessibleDropdown from 'common/AccessibleDropdown';

const filterOptions = [
  { text: "All session types", value: "bothSessionTypes" },
  { text: "Group sessions only", value: "onlyGroupSessions" },
  { text: "Single sessions only", value: "onlySingleSessions" }
];

export default class SlotTypeDropdown extends React.Component {
    render() {
        return (
            <div className={css['session-filter-container']}>
                <label className={css['session-filter-text']} id={"sessionTypeFilter"}>Filter:</label>
                <AccessibleDropdown
                    selection
                    aria-labelledby={"sessionTypeFilter"}
                    onChange={this.props.onSlotTypeDropdownChanged}
                    options={filterOptions}
                    defaultValue={filterOptions[0].value}
                    className={css['session-filter-dropdown']}
                    selectOnBlur={true}
                    selectOnNavigation={false}
                    openOnFocus={false}
                />
            </div>
        )
    }
}

SlotTypeDropdown.propTypes = {
    onSlotTypeDropdownChanged: PropTypes.func.isRequired
};
